export default __webpack_public_path__ + "media/images/search-5aa26b571247053726457121b5fca010.svg";